import { HEADER_SIZE_MAP } from '@portals/hc-rich-editor';

export const HEADING_SELECTOR = Object.keys(HEADER_SIZE_MAP).join(', ');

// Линия переключения — на две строки ниже шапки, на уровне якорного отступа статьи.
export const ACTIVE_SECTION_OFFSET = 120;
